import { useState, useContext } from "react";
import { Box, Button, Stack } from "@mui/material";
import CodeLegendsConfigurator from "./CodeLegendsConfigurator";
import MasterEntryConfigurator from "./MasterEntryConfigurator";
import { CodeLegendContext } from "../../common/contexts/CodeLegendContext";

const CodeLegendLandingPage = () => {
  const [view, setView] = useState("legends");
  const { masterEntries } = useContext(CodeLegendContext);

  return (
    <Box sx={{ p: 3 }}>
      <Stack direction='row' spacing={2} sx={{ mb: 3 }}>
        <Button
          variant={view === "legends" ? "contained" : "outlined"}
          onClick={() => setView("legends")}>
          Code Legends
        </Button>
        <Button
          variant={view === "master" ? "contained" : "outlined"}
          onClick={() => setView("master")}>
          Standard Code Descriptions
        </Button>
      </Stack>
      {view === "legends" ? (
        <CodeLegendsConfigurator />
      ) : (
        <MasterEntryConfigurator masterEntries={masterEntries || []} />
      )}
    </Box>
  );
};

export default CodeLegendLandingPage;
